import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Cookies from 'js-cookie'

const service = axios.create({
  baseURL: window.location.backendIP,
  // baseURL: "http://cxx-wx.infoclue.net/",
  // baseURL: "http://cxx-wx.infoclue.net/",
  timeout: 60000,
  headers: {"content-type":"application/json"},
});
// 添加请求拦截器，在请求头中加token
service.interceptors.request.use(
  config => {
    //if (sessionStorage.getItem('third-session')) {
      config.headers.openId = localStorage.getItem('openId')
	  config.headers.thirdsession = Cookies.get('thirdsession')
   // }
    return config;
  },
  error => {
	//如果前端拿到状态码为401，就清除token信息并跳转到登录页面
    return Promise.reject(error);
});



export default service